import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PhxColDirective } from './phx-col.directive';
import { PhxRowComponent } from './phx-row.component';

@NgModule({
  declarations: [PhxColDirective, PhxRowComponent],
  exports: [PhxColDirective, PhxRowComponent],
  imports: [CommonModule]
})
export class PhxGridModule {}